import { validateIPaddress } from "@lib/helpers/StringHelper";
import * as yup from "yup";

export const ipWhiteListSchema = yup.object().shape({
  ipWhiteList: yup
    .string()
    .nullable()
    .test({
      test: (value, context) => {
        const data = value?.split("\n");
        for (let index = 0; index < data.length; index++) {
          if (!validateIPaddress(data[index])) {
            return context.createError({ message: "Wrong IP Address" });
          }
        }
        return true;
      },
    }),
});
